import {
  Signal1973xs1vkmdcb as Signal,
  Constant3smypj7m9af27 as Constant,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render,
  ContractorPage2yk275fy06uv3 as ContractorPage,
  get_requiredMembershipRole2ywu1e77bwer8 as get_requiredMembershipRole,
} from './IsContractorScreen.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Form39thjb3imm7id as Form } from '../../components/nav/header.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { PhoneNumberFormat_USA_getInstance22618h2la6wkm as PhoneNumberFormat_USA_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments,
  LocalFileyitm5ua4ch17 as LocalFile,
} from '../../components/files/attachmentFilePreview.mjs';
import {
  modify2eca96i8s7hc2 as modify,
  set_value1vvx5pkb20ebv as set_value,
  interceptWrite2xi6g5kl52xuu as interceptWrite,
} from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import {
  Project_client_getInstance2fyj3drng1pzf as Project_client_getInstance,
  Project_name_getInstance3dymwrzmzfu1r as Project_name_getInstance,
  Project_description_getInstance1d13ic72v68j0 as Project_description_getInstance,
  Project_address_getInstance1sy7wzxhn0yu9 as Project_address_getInstance,
  Project_location_getInstance3a2xpkrgh6b4p as Project_location_getInstance,
  Project_jobNumber_getInstanceccw665heymuq as Project_jobNumber_getInstance,
  Project_files_getInstance31nstm5s64zap as Project_files_getInstance,
  Project_retention_getInstance3f845iagwlyjt as Project_retention_getInstance,
  get_nameo9a32lyl7xbh as get_name,
  get_jobNumber1ji61at3fhtkt as get_jobNumber,
  get_address2ugvw4aqvl14f as get_address,
  get_location3tupc403seoj2 as get_location,
  get_retention1b8iabda9w129 as get_retention,
  get_description1alejogxbwk1g as get_description,
  get_client1ubw0usktkrr9 as get_client,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { pushChanges2xw2hvtobowgv as pushChanges } from '../../../utils/Draft.ext.mjs';
import {
  forEachAsync1pu32d5cchlqb as forEachAsync,
  resize3py5p2yrjp6p7 as resize,
  iconAndAction2wga7n7i065rc as iconAndAction,
  round3rel4gzky0cf0 as round,
} from '../../../utils/utils.mjs';
import {
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  intercepted2ogpsikxxj4u0 as intercepted,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Projecto73xqbcrzskm as Project,
  LineItem2rt64afaiyloc as LineItem,
  Clientuccelyr89ch8 as Client,
  ContractorNote59o6kpmrrw5h as ContractorNote,
  License2dabzwgw7jcr2 as License,
  ApprovedState3hrsq7yllchx0 as ApprovedState,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope284yy3flyb2v2 as coroutineScope,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { EditLineItem2agpgpyrr30uy as EditLineItem } from '../../components/project/work/scope/EditLineItem.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../components/nav/crowpay.mjs';
import { CreateOrEditNote2axvnom01lmg9 as CreateOrEditNote } from '../../dialogs/CreateOrEditNote.mjs';
import {
  get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor,
  get_notNullContractorsjk9enub7uol as get_notNullContractor,
  get_currentContractor2yiwyln4wfsro as get_currentContractor,
} from '../../../selectedContractor.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../common/LandingScreen.mjs';
import { LogRoot_getInstance3817ahbflvs01 as LogRoot_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.js.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../dialogs/GenericDialog.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ContractorProjects2hltgp2s6pm9i as ContractorProjects } from './ContractorProjects.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from './ContractorProject.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally,
  get_padded3m3frjnjujncx as get_padded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
} from '../../theming/Titles.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  forEach37zw770vd3h4l as forEach,
  get_atStart2tgdnaxgj04ln as get_atStart,
  get_centered1xfu6or5nc0lq as get_centered,
  get_atTop15ygil3ceeuhl as get_atTop,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  times2ukvaf6yk96p2 as times,
  divkhq3vjih9fcw as div,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  weightt34o7llf2uyq as weight,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_lightSection4cpu8okr0w14 as get_lightSection,
  get_darkSection25mxxvxk8ts3b as get_darkSection,
} from '../../theming/sections.mjs';
import {
  subTitleLabel2tm7wvwblxr1h as subTitleLabel,
  label287uhiq3m9m4z as label2,
} from '../../components/label2.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  listOfvhqybd2zx248 as listOf_0,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { toList2zksu85ukrmi as toList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import {
  plus310ted5e4i90h as plus,
  plus20p0vtfmu0596 as plus_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { dialog2nk0sz8wudj8p as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  FieldLabelSemantic_getInstance23isvm7e8qjx6 as FieldLabelSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__times_impl_hlr6p72nff9ykdm2zvo as MonetaryValue__times_impl_hlr6p7,
  Addresscpovxna1tjmg as Address,
  Companion_instance357q0zxkn8vu9 as Companion_instance_0,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  assertNotBlankNamed365y7czhf0np3 as assertNotBlankNamed,
  validategsg6go7eyi9d as validate,
  branchij6ujhcuk22z as branch,
  assertReactive1648n57bmw8d1 as assertReactive,
} from '../../../utils/validation.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import {
  nullToBlank2cwx9yazfqg5v as nullToBlank,
  equalTo2dio0vrcsd3je as equalTo,
} from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import {
  errorTextv58wi1t0me7u as errorText,
  icon1sxjaie5w1apt as icon,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { ReactiveContextSuspending39biijty1bpc5 as ReactiveContextSuspending } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContextSuspending.mjs';
import { Key_instance6wd16m35aua5 as Key_instance } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { addressForm32k03uh8crpev as addressForm } from '../../components/addressForm.mjs';
import {
  assert3pektuc8qw5gc as assert,
  assertReactive30c64mz7ckt8m as assertReactive_0,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import { rangeTo5xinnemk0fd3 as rangeTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
import {
  mutableRemember1h6fyyolumj0o as mutableRemember,
  MutableRememberyv35kz5kmml7 as MutableRemember,
} from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { keyString2ezqnhf3jck9c as keyString } from '../../components/keyValue.mjs';
import { takeLast2r8kr8e6g6hi7 as takeLast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { ClientForm3gac2gni7o6s9 as ClientForm } from './ContractorClients.mjs';
import { render38qn7o0b2bza2 as render_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance } from '../../theming/appTheme.mjs';
import { formatLong1m1koxnp4gvzx as formatLong } from '../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import {
  get_edit2tiiawv2658bs as get_edit,
  get_trash3qsdn4kaynjmu as get_trash,
} from '../../../icons.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../../components/files/renderFiles.mjs';
import { fileManager1pvd5zvbyt8nt as fileManager } from '../../components/files/fileManager.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../../theming/banners.mjs';
import { leftExpandButton23soimuuf6gel as leftExpandButton } from '../../components/expansion.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import {
  get_workTabs3vd1ygveqjxgy as get_workTabs,
  InnerTabBar_getInstance20l55y0u7bopn as InnerTabBar_getInstance,
} from '../../theming/tabs.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  get_contractor1cpbosmtltvri as get_contractor,
  get_name220tirn7t92ql as get_name_0,
} from '../../../../../../crowpay-shared/com/crowpay/ClientFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { ReactiveWithMutableValue1h1r6ig7acce5 as ReactiveWithMutableValue } from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import {
  get_at1y0kiqq3vi1b7 as get_at,
  get_project34plxwa7097z4 as get_project,
} from '../../../../../../crowpay-shared/com/crowpay/ContractorNoteFields.mjs';
import { toFileData1whrjalotozwt as toFileData } from '../../../extensions/ProjectAttachment.ext.mjs';
import { EditLineItemspeyge9v529c9 as EditLineItems } from '../../components/project/work/scope/EditLineItems.mjs';
import { isNotBlank2uco4vj45ytp1 as isNotBlank } from '../../../../../../crowpay-shared/com/crowpay/extensions/Address.ext.mjs';
import { get_contractor3k6krm423825t as get_contractor_0 } from '../../../../../../crowpay-shared/com/crowpay/LicenseFields.mjs';
import { get_approvedfugbsw3v6f3w as get_approved } from '../../../../../../crowpay-shared/com/crowpay/ApprovedStateFields.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EditProjectClass;
function EditProject() {
  if (EditProjectClass === VOID) {
    class $ {
      constructor(projectId) {
        this.iet_1 = projectId;
        this.jet_1 = Signal().fak(Section_Details_getInstance());
        this.ket_1 = new (ProjectForm())(this.iet_1, this.jet_1);
        this.let_1 = MemberRole_Manager_getInstance();
      }
      ug9() {
        return this.ket_1.njj_1;
      }
      ucv() {
        return new (Constant())(this.ket_1.xji_1);
      }
      bhg() {
        return this.let_1;
      }
      rhi(_this__u8e3s4) {
        // Inline function 'kotlin.run' call
        this.ket_1.ud6(_this__u8e3s4);
      }
    }
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    protoOf($).ud6 = render;
    initMetadataForClass($, 'EditProject', VOID, VOID, [ContractorPage(), Form()]);
    EditProjectClass = $;
  }
  return EditProjectClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.cjl_1.f2();
}
function ProjectForm$Section$Companion$_anonymous__277bkf() {
  return createSimpleEnumSerializer('com.crowpay.views.screens.contractor.ProjectForm.Section', values());
}
var Section_Billing_instance;
var Section_Info_instance;
var Section_Details_instance;
var Section_Scope_instance;
function values() {
  return [Section_Billing_getInstance(), Section_Info_getInstance(), Section_Details_getInstance(), Section_Scope_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.cjl_1 = lazy(tmp_0, ProjectForm$Section$Companion$_anonymous__277bkf);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  Section_initEntries();
  if (Companion_instance_1 === VOID)
    new (Companion())();
  return Companion_instance_1;
}
var Section_entriesInitialized;
function Section_initEntries() {
  if (Section_entriesInitialized)
    return Unit_instance;
  Section_entriesInitialized = true;
  Section_Billing_instance = Section().gjl('Billing', 0, 'Billing');
  Section_Info_instance = Section().gjl('Info', 1, 'Info');
  Section_Details_instance = Section().gjl('Details', 2, 'Details');
  Section_Scope_instance = Section().gjl('Scope', 3, 'Scope');
  Companion_getInstance_1();
}
var $ENTRIES;
var NoneClass;
function None() {
  if (NoneClass === VOID) {
    class $ extends ClientSelection() {
      constructor() {
        None_instance = null;
        super('Select Client');
        None_instance = this;
      }
      toString() {
        return 'None';
      }
      hashCode() {
        return 1972673022;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof None()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'None');
    NoneClass = $;
  }
  return NoneClass;
}
var None_instance;
function None_getInstance() {
  if (None_instance === VOID)
    new (None())();
  return None_instance;
}
var NewClass;
function New() {
  if (NewClass === VOID) {
    class $ extends ClientSelection() {
      constructor() {
        New_instance = null;
        super('+ New Client');
        New_instance = this;
      }
      toString() {
        return 'New';
      }
      hashCode() {
        return 756370970;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof New()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'New');
    NewClass = $;
  }
  return NewClass;
}
var New_instance;
function New_getInstance() {
  if (New_instance === VOID)
    new (New())();
  return New_instance;
}
var ExistingClass;
function Existing() {
  if (ExistingClass === VOID) {
    class $ extends ClientSelection() {
      constructor(client) {
        // Inline function 'kotlin.takeIf' call
        var this_0 = client.f5c_1;
        var tmp;
        // Inline function 'kotlin.text.isNotBlank' call
        if (!isBlank(this_0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.takeIf' call
          var this_1 = client.i5c_1;
          var tmp_1;
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(this_1)) {
            tmp_1 = this_1;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp1_elvis_lhs = tmp_0;
        var tmp_2;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.takeIf' call
          var this_2 = client.j5c_1;
          var tmp_3;
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(this_2)) {
            tmp_3 = this_2;
          } else {
            tmp_3 = null;
          }
          var tmp2_safe_receiver = tmp_3;
          var tmp_4;
          if (tmp2_safe_receiver == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_5 = PhoneNumberFormat_USA_getInstance();
            // Inline function 'kotlin.text.filter' call
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().d1();
            var inductionVariable = 0;
            var last = charSequenceLength(tmp2_safe_receiver);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(tmp2_safe_receiver, index);
                if (isDigit(element)) {
                  destination.xb(element);
                }
              }
               while (inductionVariable < last);
            var tmp$ret$11 = destination.toString();
            tmp_4 = tmp_5.yda(tmp$ret$11);
          }
          tmp_2 = tmp_4;
        } else {
          tmp_2 = tmp1_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp_2;
        super(tmp3_elvis_lhs == null ? 'Existing Client' : tmp3_elvis_lhs);
        this.jjl_1 = client;
      }
      toString() {
        return 'Existing(client=' + this.jjl_1.toString() + ')';
      }
      hashCode() {
        return this.jjl_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Existing()))
          return false;
        if (!this.jjl_1.equals(other.jjl_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Existing');
    ExistingClass = $;
  }
  return ExistingClass;
}
function *_generator_invoke__zhh2q8($this, item, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.kjl_1.yji_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp) {
    var tmp_0 = $this.kjl_1.ljl(false, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.mjl_1.djj_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = resolveProjectAttachments(tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp1_files = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.mjl_1.kjj_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0_safe_receiver = tmp_1;
  var tmp2_client = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d5c_1;
  return it.m7c(VOID, VOID, VOID, VOID, VOID, tmp2_client, VOID, VOID, VOID, VOID, VOID, tmp1_files);
}
function *_generator_invoke__zhh2q8_1($this, $this$coroutineScope, $completion) {
  var tmp = modify($this.njl_1.bjj_1, ProjectForm$saveProject$slambda$slambda_0($this.njl_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  var tmp_1 = pushChanges($this.njl_1.bjj_1, tmp$ret$0.pfv_1, listOf([Project_client_getInstance(), Project_name_getInstance(), Project_description_getInstance(), Project_address_getInstance(), Project_location_getInstance(), Project_jobNumber_getInstance(), Project_files_getInstance(), Project_retention_getInstance()]), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  if ($this.ojl_1) {
    var tmp_2 = awaitOnce($this.njl_1.fjj_1.kho_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp_3 = forEachAsync(tmp_2, 5, ProjectForm$saveProject$slambda$slambda_2(), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
var ProjectForm$saveProject$slambda$slambdaClass;
function ProjectForm$saveProject$slambda$slambda() {
  if (ProjectForm$saveProject$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.mjl_1 = this$0;
      }
      pjl(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.pjl(p1 instanceof Project() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$saveProject$slambda$slambdaClass = $;
  }
  return ProjectForm$saveProject$slambda$slambdaClass;
}
function ProjectForm$saveProject$slambda$slambda_0(this$0) {
  var i = new (ProjectForm$saveProject$slambda$slambda())(this$0);
  var l = (it, $completion) => i.pjl(it, $completion);
  l.$arity = 1;
  return l;
}
var ProjectForm$saveProject$slambda$slambdaClass_0;
function ProjectForm$saveProject$slambda$slambda_1() {
  if (ProjectForm$saveProject$slambda$slambdaClass_0 === VOID) {
    class $ {
      qjl($this$forEachAsync, it, $completion) {
        it.jhn_1.xbe($this$forEachAsync);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE();
        return this.qjl(tmp, p2 instanceof EditLineItem() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ProjectForm$saveProject$slambda$slambdaClass_0 = $;
  }
  return ProjectForm$saveProject$slambda$slambdaClass_0;
}
function ProjectForm$saveProject$slambda$slambda_2() {
  var i = new (ProjectForm$saveProject$slambda$slambda_1())();
  var l = ($this$forEachAsync, it, $completion) => i.qjl($this$forEachAsync, it, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.rjl_1.ljj_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.rjl_1.kjj_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp0_safe_receiver = tmp_0;
    var billing = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k5c_1;
    if (!(billing == null)) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = $this.rjl_1.bjj_1;
      var tmp_1 = await_0(this_2, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var tmp$ret$2 = tmp_1;
      var tmp_2 = $this.rjl_1.bjj_1.gah(tmp$ret$2.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, billing), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, newClient, saved, $completion) {
  if (saved) {
    var tmp = $this.sjl_1.gah(new (Existing())(newClient), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    set_value($this.tjl_1.kjj_1, newClient);
  } else {
    var tmp0_safe_receiver = $this.ujl_1._v;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.njf_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.mam(false);
    }
    var tmp_0 = $this.sjl_1.gah(None_getInstance(), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.vjl_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.xgd(CreateOrEditNote().th1(tmp$ret$0, 'Add notes, pictures, or files that are for INTERNAL team only.  (ie. client or property considerations for managers and crews.)'));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.zfv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.wjl_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = tmp_0.kft(tmp$ret$1.d5p_1).iem($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var ProjectForm$projectDetailForm$lambda$lambda$slambda$slambdaClass;
function ProjectForm$projectDetailForm$lambda$lambda$slambda$slambda() {
  if (ProjectForm$projectDetailForm$lambda$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($note) {
        this.wjl_1 = $note;
      }
      cgk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$projectDetailForm$lambda$lambda$slambda$slambdaClass = $;
  }
  return ProjectForm$projectDetailForm$lambda$lambda$slambda$slambdaClass;
}
function ProjectForm$projectDetailForm$lambda$lambda$slambda$slambda_0($note) {
  var i = new (ProjectForm$projectDetailForm$lambda$lambda$slambda$slambda())($note);
  var l = (it, $completion) => i.cgk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = $this.xjl_1.ljl(false, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $this$iconAndAction, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.yjl_1.bjj_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.x7a_1;
  tmp.xgd(CreateOrEditNote().gh0(tmp_1, null, 'Add notes, pictures, or files that are for INTERNAL team only.  (ie. client or property considerations for managers and crews.)', ProjectForm$projectDetailForm$lambda$slambda$slambda_0($this.yjl_1)));
  return Unit_instance;
}
var ProjectForm$projectDetailForm$lambda$slambda$slambdaClass;
function ProjectForm$projectDetailForm$lambda$slambda$slambda() {
  if (ProjectForm$projectDetailForm$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.xjl_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$projectDetailForm$lambda$slambda$slambdaClass = $;
  }
  return ProjectForm$projectDetailForm$lambda$slambda$slambdaClass;
}
function ProjectForm$projectDetailForm$lambda$slambda$slambda_0(this$0) {
  var i = new (ProjectForm$projectDetailForm$lambda$slambda$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2ProjectLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().pfg_1);
}
var LiveApi2$Api2ProjectLive$uploadFileForRequest$refClass;
function LiveApi2$Api2ProjectLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2ProjectLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.zjl_1 = p0;
      }
      sao($completion) {
        return this.zjl_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2ProjectLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2ProjectLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2ProjectLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2ProjectLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $this$launch, $completion) {
  var tmp = await_0(get_session(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ajm_1.bjj_1.yaj();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var p = tmp_0;
  var tmp_1 = await_1(get_selectedContractor(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  if (!equals(tmp_1, p.z7a_1)) {
    var tmp_2 = await_0(session.pfw_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var self_0 = tmp_2;
    var tmp_3;
    if (!(self_0.m88_1 == null)) {
      var tmp0_safe_receiver = self_0.m88_1;
      tmp_3 = equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i8c_1, p.z7a_1);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      var tmp_4 = get_selectedContractor().gah(p.z7a_1, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
    } else {
      get_pageNavigator($this.bjm_1).ebw(new (LandingScreen())());
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  try {
    var tmp = $this.cjm_1.ejm($this.djm_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      LogRoot_getInstance().ddo([e]);
      get_dialogStack().xgd(GenericDialog().zgy('Failed to save project'));
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  try {
    var tmp = $this.fjm_1.ejm($this.gjm_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    get_pageNavigator($this.gjm_1).ebw(new (ContractorProjects())());
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      get_dialogStack().xgd(GenericDialog().zgy('Failed to save project'));
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
var ProjectForm$actionBar$discardButton$slambda$slambdaClass;
function ProjectForm$actionBar$discardButton$slambda$slambda() {
  if (ProjectForm$actionBar$discardButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.hjm_1 = $$this$button;
      }
      cgk(confirmed, $completion) {
        if (!confirmed)
          return Unit_instance;
        get_pageNavigator(this.hjm_1).ebw(new (ContractorProjects())());
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$actionBar$discardButton$slambda$slambdaClass = $;
  }
  return ProjectForm$actionBar$discardButton$slambda$slambdaClass;
}
function ProjectForm$actionBar$discardButton$slambda$slambda_0($$this$button) {
  var i = new (ProjectForm$actionBar$discardButton$slambda$slambda())($$this$button);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_12($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp.pfv_1.kft($this.ijm_1.vji_1).iem($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    get_pageNavigator($this.jjm_1).ebw(new (ContractorProjects())());
  }
  return Unit_instance;
}
var ProjectForm$actionBar$deleteButton$slambda$slambdaClass;
function ProjectForm$actionBar$deleteButton$slambda$slambda() {
  if (ProjectForm$actionBar$deleteButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.ijm_1 = this$0;
        this.jjm_1 = $$this$button;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$actionBar$deleteButton$slambda$slambdaClass = $;
  }
  return ProjectForm$actionBar$deleteButton$slambda$slambdaClass;
}
function ProjectForm$actionBar$deleteButton$slambda$slambda_0(this$0, $$this$button) {
  var i = new (ProjectForm$actionBar$deleteButton$slambda$slambda())(this$0, $$this$button);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_13($this, it, $completion) {
  if (it) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var session = tmp;
    var tmp_0 = session.tfw().pfg_1.afp($this.kjm_1.vji_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = delay(100n, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = session.pfv_1.beo($completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    get_pageNavigator($this.ljm_1).ebw(new (ContractorProject())($this.kjm_1.vji_1));
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  var tmp = awaitOnce($this.mjm_1.bjj_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var p = tmp;
  var tmp_0 = awaitOnce($this.mjm_1.djj_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var f = tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4 = awaitOnce($this.mjm_1.bjj_1.aak(), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  if (tmp_4) {
    tmp_3 = true;
  } else {
    tmp_3 = !(p.i7b_1.p1() === f.p1());
  }
  if (tmp_3) {
    tmp_2 = true;
  } else {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_5;
      if (isInterface(f, Collection())) {
        tmp_5 = f.i1();
      } else {
        tmp_5 = false;
      }
      if (tmp_5) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = f.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp_6 = element.agc_1;
        if (tmp_6 instanceof LocalFile()) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp_2 = tmp$ret$0;
  }
  if (tmp_2) {
    tmp_1 = true;
  } else {
    var tmp_7 = $this.mjm_1.fjj_1.vho($completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    tmp_1 = tmp_7;
  }
  if (tmp_1) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.ra5();
    var tmp_8 = get_dialogStack();
    tmp_8.xgd(new (GenericConfirmationDialog())('Save Project?', 'This project has unsaved changes. You must save the these changes before you can publish.', VOID, 'Save Project', VOID, VOID, VOID, VOID, VOID, VOID, ProjectForm$actionBar$publishButton$slambda$slambda_0(cancellable)));
    cancellable.ta7(ProjectForm$actionBar$publishButton$slambda$lambda);
    var tmp$ret$3 = cancellable.sa5();
    var tmp_9 = returnIfSuspended(tmp$ret$3, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
    var confirmed = tmp_9;
    if (confirmed) {
      var tmp_10 = $this.mjm_1.ljl(true, $completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
      var tmp_11 = delay(1000n, $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
    } else
      return Unit_instance;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.mjm_1.mjj_1;
  var tmp_12 = await_0(this_0, $completion);
  if (tmp_12 === get_COROUTINE_SUSPENDED())
    tmp_12 = yield tmp_12;
  if (tmp_12) {
    get_dialogStack().xgd(GenericDialog().zgy('Projects can only by published by contractors registered to operate in approved states.'));
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.mjm_1.zji_1.pat_1;
    var tmp_13 = await_0(this_1, $completion);
    if (tmp_13 === get_COROUTINE_SUSPENDED())
      tmp_13 = yield tmp_13;
    if (tmp_13.i1()) {
      $this.mjm_1.ajj_1.mam(false);
      var tmp_14 = get_dialogStack();
      tmp_14.xgd(new (GenericConfirmationDialog())('Publish Project?', 'Publishing a new project will make it available to view and be accepted by the client. Please make sure all project details are correct before proceeding. Once the client accepts, any changes will need mutual agreement.', VOID, 'Publish Project', VOID, VOID, VOID, VOID, VOID, VOID, ProjectForm$actionBar$publishButton$slambda$slambda_2($this.mjm_1, $this.njm_1)));
    } else {
      $this.mjm_1.ajj_1.mam(true);
      dialog($this.njm_1, VOID, ($this$dialog, close) => {
        var tmp0_height = get_rem(30);
        var tmp1_width = get_rem(37);
        var tmp = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, tmp1_width, tmp0_height);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())($this$dialog.pc());
        var tmp0_elvis_lhs = $this$dialog.cbb_1;
        var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
        $this$dialog.ebb(p, view);
        view.xbm(true);
        title(view, 'Invalid Fields');
        body(view, 'There are some invalid fields on your project. Please fix the following issues and try again:');
        var tmp_0 = view.ibb(get_expanding(view), get_scrolling(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        view_0.zb8(times(view_0.kba().hb0_1, 2));
        var tmp_1 = view_0.ibb(shownWhen(view_0, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.baj(get_issues($this.mjm_1.bjj_1)).i1();
        }), get_expanding(view_0));
        view_0.jbb(tmp_1, subTitleLabel(view_0, 'Project Issues', ($this$subTitleLabel) => {
          var tmp = get_lightSection($this$subTitleLabel);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$subTitleLabel.pc());
          var tmp0_elvis_lhs = $this$subTitleLabel.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$subTitleLabel : tmp0_elvis_lhs;
          $this$subTitleLabel.ebb(p, view);
          view.xbm(true);
          var tmp_0 = get_issues($this.mjm_1.bjj_1);
          forEach(view, tmp_0, ProjectForm$actionBar$publishButton$slambda$lambda$lambda$lambda);
          $this$subTitleLabel.fbb(p, view);
          return $this$subTitleLabel.jbb(tmp, view);
        }));
        var itemIssues = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = listOf_0(to(null, $this$remember.baj($this.mjm_1.gjj_1.pat_1)));
          // Inline function 'kotlin.collections.associate' call
          var this_0 = $this$remember.baj($this.mjm_1.fjj_1.kho_1);
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
          // Inline function 'kotlin.collections.associateTo' call
          var destination = LinkedHashMap().fc(capacity);
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.text.ifBlank' call
            var this_1 = $this$remember.baj(element.chn_1).l6k_1;
            var tmp_0;
            if (isBlank(this_1)) {
              tmp_0 = 'New Work Item';
            } else {
              tmp_0 = this_1;
            }
            var tmp$ret$14 = tmp_0;
            // Inline function 'kotlin.collections.plusAssign' call
            var pair = to(tmp$ret$14, $this$remember.baj(get_issues(element.chn_1)));
            destination.s3(pair.af_1, pair.bf_1);
          }
          var everything = plus(tmp, toList(destination));
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = everything.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!element_0.bf_1.i1()) {
              destination_0.v(element_0);
            }
          }
          return destination_0;
        });
        var tmp_2 = view_0.ibb(shownWhen(view_0, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.baj(itemIssues).i1();
        }), get_expanding(view_0));
        view_0.jbb(tmp_2, subTitleLabel(view_0, 'Scope Issues', ($this$subTitleLabel) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$subTitleLabel.pc());
          var tmp0_elvis_lhs = $this$subTitleLabel.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$subTitleLabel : tmp0_elvis_lhs;
          $this$subTitleLabel.ebb(p, view);
          view.xbm(true);
          forEach(view, itemIssues, ProjectForm$actionBar$publishButton$slambda$lambda$lambda$lambda_0);
          $this$subTitleLabel.fbb(p, view);
          return view;
        }));
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        var tmp_3 = view.ibb(get_atStart(view), get_primaryButton(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Button())(view.pc());
        var tmp0_elvis_lhs_1 = view.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.ebb(p_1, view_1);
        specCenteredText(view_1, 'Close');
        onClick(view_1, VOID, VOID, ProjectForm$actionBar$publishButton$slambda$lambda$slambda_0(close));
        view.fbb(p_1, view_1);
        view.jbb(tmp_3, view_1);
        $this$dialog.fbb(p, view);
        $this$dialog.jbb(tmp, view);
        return Unit_instance;
      });
    }
  }
  return Unit_instance;
}
var ProjectForm$actionBar$publishButton$slambda$slambdaClass;
function ProjectForm$actionBar$publishButton$slambda$slambda() {
  if (ProjectForm$actionBar$publishButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor($cont) {
        this.ojm_1 = $cont;
      }
      cgk(confirmed, $completion) {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = this.ojm_1;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$0 = _Result___init__impl__xyqfz8(confirmed);
        this_0.rc(tmp$ret$0);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$actionBar$publishButton$slambda$slambdaClass = $;
  }
  return ProjectForm$actionBar$publishButton$slambda$slambdaClass;
}
function ProjectForm$actionBar$publishButton$slambda$slambda_0($cont) {
  var i = new (ProjectForm$actionBar$publishButton$slambda$slambda())($cont);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function ProjectForm$actionBar$publishButton$slambda$lambda(it) {
  get_dialogStack().ngd();
  return Unit_instance;
}
var ProjectForm$actionBar$publishButton$slambda$slambdaClass_0;
function ProjectForm$actionBar$publishButton$slambda$slambda_1() {
  if (ProjectForm$actionBar$publishButton$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.kjm_1 = this$0;
        this.ljm_1 = $$this$button;
      }
      cgk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$actionBar$publishButton$slambda$slambdaClass_0 = $;
  }
  return ProjectForm$actionBar$publishButton$slambda$slambdaClass_0;
}
function ProjectForm$actionBar$publishButton$slambda$slambda_2(this$0, $$this$button) {
  var i = new (ProjectForm$actionBar$publishButton$slambda$slambda_1())(this$0, $$this$button);
  var l = (it, $completion) => i.cgk(it, $completion);
  l.$arity = 1;
  return l;
}
function ProjectForm$actionBar$publishButton$slambda$lambda$lambda$lambda($this$forEach, it) {
  actionBar$publishButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderIssue_eqxfvq($this$forEach, it);
  return Unit_instance;
}
function ProjectForm$actionBar$publishButton$slambda$lambda$lambda$lambda_0($this$forEach, _destruct__k2r9zo) {
  var name = _destruct__k2r9zo.cf();
  var issues = _destruct__k2r9zo.df();
  if (name == null) {
    var tmp = get_lightSection($this$forEach);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEach.pc());
    var tmp0_elvis_lhs = $this$forEach.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
    $this$forEach.ebb(p, view);
    view.xbm(true);
    var _iterator__ex2g4s = issues.m1();
    while (_iterator__ex2g4s.n1()) {
      var issue = _iterator__ex2g4s.o1();
      actionBar$publishButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderIssue_eqxfvq(view, issue);
    }
    $this$forEach.fbb(p, view);
    $this$forEach.jbb(tmp, view);
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.label' call
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())($this$forEach.pc());
    var tmp0_elvis_lhs_0 = $this$forEach.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? $this$forEach : tmp0_elvis_lhs_0;
    $this$forEach.ebb(p_0, view_0);
    view_0.xbm(true);
    view_0.jbb(view_0.hbb(FieldLabelSemantic_getInstance()), text(view_0, name));
    view_0.bbn(get_px(0));
    var tmp_0 = get_lightSection(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.xbm(true);
    var _iterator__ex2g4s_0 = issues.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var issue_0 = _iterator__ex2g4s_0.o1();
      actionBar$publishButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderIssue_eqxfvq(view_1, issue_0);
    }
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_0, view_1);
    $this$forEach.fbb(p_0, view_0);
  }
  return Unit_instance;
}
var ProjectForm$actionBar$publishButton$slambda$lambda$slambdaClass;
function ProjectForm$actionBar$publishButton$slambda$lambda$slambda() {
  if (ProjectForm$actionBar$publishButton$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($close) {
        this.pjm_1 = $close;
      }
      sao($completion) {
        this.pjm_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$actionBar$publishButton$slambda$lambda$slambdaClass = $;
  }
  return ProjectForm$actionBar$publishButton$slambda$lambda$slambdaClass;
}
function ProjectForm$actionBar$publishButton$slambda$lambda$slambda_0($close) {
  var i = new (ProjectForm$actionBar$publishButton$slambda$lambda$slambda())($close);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var SectionClass;
function Section() {
  if (SectionClass === VOID) {
    class $ extends Enum() {
      static gjl(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.fjl_1 = displayName;
        return $this;
      }
      g90() {
        return this.fjl_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'Section', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_1});
    SectionClass = $;
  }
  return SectionClass;
}
function *_generator_saveProject__mbt0ko($this, includeLineItems, $completion) {
  var tmp = coroutineScope(ProjectForm$saveProject$slambda_0($this, includeLineItems), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_saveProject__mbt0ko_0($this, _this__u8e3s4, $completion) {
  var tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.fjj_1.kho_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0.i1()) {
    tmp = false;
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.yji_1;
    var tmp_1 = await_0(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    if (!tmp_1) {
      tmp = true;
    } else {
      var tmp_2 = $this.fjj_1.vho($completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      if (tmp_2) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
        cancellable.ra5();
        var cont = cancellable;
        var tmp_3 = get_dialogStack();
        tmp_3.xgd(new (GenericConfirmationDialog())('Save Work Items', 'You have unsaved changes in your work items. Do you wish to save those now as well?', VOID, 'Include Work Items', 'Only Project', VOID, VOID, VOID, VOID, VOID, ProjectForm$saveProject$slambda_2(cont)));
        cont.ta7((it) => {
          get_dialogStack().ngd();
          // Inline function 'kotlin.coroutines.resume' call
          var this_0 = cont;
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$2 = _Result___init__impl__xyqfz8(false);
          this_0.rc(tmp$ret$2);
          return Unit_instance;
        });
        var tmp$ret$5 = cancellable.sa5();
        var tmp_4 = returnIfSuspended(tmp$ret$5, $completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        tmp = tmp_4;
      } else {
        tmp = false;
      }
    }
  }
  var includeLineItems = tmp;
  println('Include line items: ' + includeLineItems);
  var tmp_5 = $this.ljl(includeLineItems, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
function actionBar($this, _this__u8e3s4) {
  var tmp = get_darkSection(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.eba(div(get_AppDimensions().xg1_1, 2));
  view.zb8(div(get_AppDimensions().xg1_1, 2));
  if (get_viewIsNarrow(view)) {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    view_0.zb8(get_AppDimensions().ig2_1);
    actionBar$deleteButton(view_0, $this);
    var tmp_0 = get_expanding(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Space())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_0, view_1);
    view_0.jbb(get_secondaryButton(view_0), actionBar$saveButton(view_0, $this));
    actionBar$publishButton(view_0, $this);
    view.fbb(p_0, view_0);
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    view_2.xbm(false);
    view_2.zb8(get_AppDimensions().ig2_1);
    view_2.jbb(get_primaryButton(view_2), actionBar$saveButton(view_2, $this));
    actionBar$saveAndCloseButton(view_2, $this);
    actionBar$discardButton(view_2);
    view_2.jbb(shownWhen(view_2, VOID, ($this$shownWhen) => $this$shownWhen.baj($this.yji_1)), actionBar$deleteButton(view_2, $this));
    var tmp_1 = get_expanding(view_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Space())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    view_2.fbb(p_3, view_3);
    view_2.jbb(tmp_1, view_3);
    actionBar$publishButton(view_2, $this);
    view.fbb(p_2, view_2);
  }
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function projectInfo($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label = 'Project Name';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(get_AppDimensions().ng2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  view_1.zb8(get_AppDimensions().pg2_1);
  view_1.jbb(get_centered(view_1), bodyBold(view_1, label));
  view_1.jbb(colored(view_1, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_1, '*'));
  view_0.fbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view_0.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_0 = $this.bjj_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$5);
  var tmp$ret$7 = get_name(it);
  var tmp$ret$8 = lensPath(this_0, tmp$ret$7);
  var value = assertNotBlankNamed(tmp$ret$8, 'Name');
  var tmp_1 = validate(view_0, value, ($this$validate) => $this$validate.baj($this.ajj_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextInput())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
  var value_0 = 'Project Name';
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_2.tb5_1.zb3_1.ib7_1.placeholder = value_0;
  view_2.xah(view_2.gcn_1, value);
  view_0.fbb(p_2, view_2);
  view_0.jbb(tmp_1, view_2);
  var tmp_2 = get_issues(value);
  var tmp$ret$14 = issueText(view_0, tmp_2, VOID, ($this$issueText) => $this$issueText.baj($this.ajj_1));
  view_0.jbb(tmp, tmp$ret$14);
  view.fbb(p_0, view_0);
  // Inline function 'com.crowpay.views.components.field2' call
  var label_0 = 'Job#/PO (Optional)';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_3 = view.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.ebb(p_3, view_3);
  view_3.xbm(true);
  view_3.zb8(get_AppDimensions().ng2_1);
  bodyBold(view_3, label_0);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_3 = view_3.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextInput())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.ebb(p_4, view_4);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_1 = $this.bjj_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_4 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$21 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$21);
  var tmp$ret$23 = get_jobNumber(it_0);
  var tmp$ret$24 = lensPath(this_1, tmp$ret$23);
  view_4.xah(view_4.gcn_1, nullToBlank(tmp$ret$24));
  view_3.fbb(p_4, view_4);
  view_3.jbb(tmp_3, view_4);
  view_3.jbb(view_3.hbb(SubtextSemantic_getInstance()), errorText(view_3));
  view.fbb(p_3, view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Space())(view.pc());
  var tmp0_elvis_lhs_5 = view.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
  view.ebb(p_5, view_5);
  view.fbb(p_5, view_5);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = 'Project Address';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_6 = view.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.ebb(p_6, view_6);
  view_6.jba(view_6.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_5 = view_6.tb5_1;
  var tmp_6;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_6 = '\xA0';
  } else {
    tmp_6 = content;
  }
  tmp_5.fbu(tmp_6);
  view.fbb(p_6, view_6);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_7 = view.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
  view.ebb(p_7, view_7);
  view_7.xbm(false);
  view_7.hb7(false);
  var tmp_7 = KMutableProperty0();
  var tmp_8 = RowOrCol$_get_shown_$ref_m8lfse(view_7);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('shown', 0, tmp_7, tmp_8, RowOrCol$_set_shown_$ref_7290m6(view_7));
  reactiveScope(view_7, ($this$reactiveScope) => {
    var tmp$ret$43 = !($this$reactiveScope.baj($this.kjj_1) == null);
    this_2.set(tmp$ret$43);
    return Unit_instance;
  });
  var tmp_9 = get_centered(view_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (Checkbox())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.ebb(p_8, view_8);
  view_8.xah(view_8.cbk_1, $this.ljj_1);
  view_7.fbb(p_8, view_8);
  view_7.jbb(tmp_9, view_8);
  view_7.jbb(get_centered(view_7), body(view_7, 'Same As Client Address'));
  // Inline function 'com.lightningkite.reactive.context.reactiveSuspending' call
  var action = ProjectForm$projectInfo$slambda_0($this);
  // Inline function 'kotlin.also' call
  var this_3 = new (ReactiveContextSuspending())(view_7, VOID, VOID, action);
  this_3.yai();
  var tmp0_safe_receiver = view_7.ea2().cd(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.cah(this_3);
  }
  view.fbb(p_7, view_7);
  var tmp_10 = shownWhen(view, VOID, ($this$shownWhen) => !$this$shownWhen.baj($this.ljj_1));
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_4 = $this.bjj_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_11 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$55 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$55);
  var tmp$ret$57 = get_address(it_1);
  var tmp_12 = lensPath(this_4, tmp$ret$57);
  var tmp_13 = get_AppDimensions().fg2_1;
  var tmp_14 = ($this$addressForm) => $this$addressForm.baj($this.ljj_1);
  view.jbb(tmp_10, addressForm(view, tmp_12, tmp_13, VOID, tmp_14, ($this$addressForm) => $this$addressForm.baj($this.ajj_1)));
  // Inline function 'com.crowpay.views.components.field2' call
  var label_1 = 'Neighborhood/District (Optional)';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_9 = view.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view : tmp0_elvis_lhs_9;
  view.ebb(p_9, view_9);
  view_9.xbm(true);
  view_9.zb8(get_AppDimensions().ng2_1);
  bodyBold(view_9, label_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_15 = view_9.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (TextInput())(view_9.pc());
  var tmp0_elvis_lhs_10 = view_9.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
  view_9.ebb(p_10, view_10);
  // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
  var value_1 = 'Neighborhood/District';
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_10.tb5_1.zb3_1.ib7_1.placeholder = value_1;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_5 = $this.bjj_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_16 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$62 = isInterface(tmp_16, KSerializer()) ? tmp_16 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$62);
  var tmp$ret$64 = get_location(it_2);
  var tmp$ret$65 = lensPath(this_5, tmp$ret$64);
  view_10.xah(view_10.gcn_1, nullToBlank(tmp$ret$65));
  view_9.fbb(p_10, view_10);
  view_9.jbb(tmp_15, view_10);
  view_9.jbb(view_9.hbb(SubtextSemantic_getInstance()), errorText(view_9));
  view.fbb(p_9, view_9);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_6 = $this.bjj_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_17 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$75 = isInterface(tmp_17, KSerializer()) ? tmp_17 : THROW_CCE();
  var it_3 = new (DataClassPathSelf())(tmp$ret$75);
  var tmp$ret$77 = get_retention(it_3);
  var tmp_18 = lensPath(this_6, tmp$ret$77);
  var tmp_19 = ProjectForm$projectInfo$lambda;
  var tmp_20 = tmp_18.tak(tmp_19, ProjectForm$projectInfo$lambda_0);
  var retention = assert(tmp_20, 'Retention must be between 0 and 5 percent', VOID, VOID, ProjectForm$projectInfo$lambda_1);
  // Inline function 'com.crowpay.views.components.field2' call
  var label_2 = 'Retention (Percent)';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_11 = view.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view : tmp0_elvis_lhs_11;
  view.ebb(p_11, view_11);
  view_11.xbm(true);
  view_11.zb8(get_AppDimensions().ng2_1);
  bodyBold(view_11, label_2);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_21 = view_11.hbb(FieldSemantic_getInstance());
  var tmp_22 = validate(view_11, retention);
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (NumberInput())(view_11.pc());
  var tmp0_elvis_lhs_12 = view_11.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
  view_11.ebb(p_12, view_12);
  view_12.xah(view_12.xc5_1, retention);
  view_12.cc6(rangeTo(0.0, 5.0));
  // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
  var value_2 = '0% to 5%';
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_12.tb5_1.zb3_1.ib7_1.placeholder = value_2;
  view_11.fbb(p_12, view_12);
  view_11.jbb(tmp_22, view_12);
  var tmp$ret$85 = issueText(view_11, get_issues(retention));
  view_11.jbb(tmp_21, tmp$ret$85);
  view_11.jbb(view_11.hbb(SubtextSemantic_getInstance()), errorText(view_11));
  view.fbb(p_11, view_11);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_13 = view.cbb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view : tmp0_elvis_lhs_13;
  view.ebb(p_13, view_13);
  view_13.xbm(true);
  label2(view_13, 'Total Price (Calculated from line items)', VOID, ($this$label2) => {
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$label2.pc());
    var tmp0_elvis_lhs = $this$label2.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
    $this$label2.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var tmp$ret$91 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.baj($this.hjj_1).a5s_1);
      this_0.set(tmp$ret$91);
      return Unit_instance;
    });
    $this$label2.fbb(p, view);
    return view;
  });
  var tmp_23 = shownWhen(view_13, VOID, ($this$shownWhen) => !($this$shownWhen.baj($this.bjj_1).j7b_1 == null));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (RowOrCol())(view_13.pc());
  var tmp0_elvis_lhs_14 = view_13.cbb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.ebb(p_14, view_14);
  view_14.xbm(true);
  label2(view_14, 'Total Retention', VOID, ($this$label2) => {
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$label2.pc());
    var tmp0_elvis_lhs = $this$label2.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
    $this$label2.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_0(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var t = $this$reactiveScope.baj($this.hjj_1).a5s_1;
      var tmp0_elvis_lhs = $this$reactiveScope.baj($this.bjj_1).j7b_1;
      var r = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
      var tmp$ret$98 = MonetaryValue__toString_impl_xslc77(MonetaryValue__times_impl_hlr6p7(t, r));
      this_0.set(tmp$ret$98);
      return Unit_instance;
    });
    $this$label2.fbb(p, view);
    return view;
  });
  view_13.fbb(p_14, view_14);
  view_13.jbb(tmp_23, view_14);
  view.fbb(p_13, view_13);
  _this__u8e3s4.fbb(p, view);
  return view;
}
var ClientSelectionClass;
function ClientSelection() {
  if (ClientSelectionClass === VOID) {
    class $ {
      constructor(displayName) {
        this.hjl_1 = displayName;
      }
      g90() {
        return this.hjl_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'ClientSelection', VOID, VOID, [HasDisplayName()]);
    ClientSelectionClass = $;
  }
  return ClientSelectionClass;
}
function billingInfo($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var tmp = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
    var tmp0_safe_receiver = $this$mutableRemember.baj($this.kjj_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new (Existing())(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? $this$mutableRemember.baj($this.ijj_1).i1() ? New_getInstance() : None_getInstance() : tmp1_elvis_lhs;
  });
  var clientSelection = interceptWrite(tmp, ProjectForm$billingInfo$slambda_0($this));
  // Inline function 'com.crowpay.views.components.requiredField' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(get_AppDimensions().ng2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  view_1.zb8(get_AppDimensions().pg2_1);
  view_1.jbb(get_centered(view_1), bodyBold(view_1, 'Client'));
  view_1.jbb(colored(view_1, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_1, '*'));
  view_0.fbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_0 = view_0.hbb(FieldSemantic_getInstance());
  var clientCondition = branch($this.bjj_1);
  assertReactive_0(clientCondition, 'Must have a selected client', VOID, ($this$assertReactive, it) => !($this$assertReactive.baj($this.kjj_1) == null));
  var tmp_1 = validate(view_0, clientCondition, ($this$validate) => $this$validate.baj($this.ajj_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Select())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  var tmp_2 = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp = listOf_0(None_getInstance());
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$remember.baj($this.ijj_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$7 = new (Existing())(item);
      destination.v(tmp$ret$7);
    }
    return plus_0(plus(tmp, destination), New_getInstance());
  });
  view_2.mcf(clientSelection, tmp_2, ProjectForm$billingInfo$lambda);
  view_0.fbb(p_2, view_2);
  view_0.jbb(tmp_1, view_2);
  var tmp_3 = get_issues(clientCondition);
  var tmp$ret$13 = issueText(view_0, tmp_3, VOID, ($this$issueText) => $this$issueText.baj($this.ajj_1));
  view_0.jbb(tmp_0, tmp$ret$13);
  view.fbb(p_0, view_0);
  var tmp_4 = view.ibb(shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp = $this$shownWhen.baj(clientSelection);
    return tmp instanceof Existing();
  }), get_lightSection(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_3 = view.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.ebb(p_3, view_3);
  view_3.xbm(true);
  keyString(view_3, 'Contact Name', ($this$keyString) => {
    var tmp0_safe_receiver = $this$keyString.baj($this.kjj_1);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n92();
  });
  keyString(view_3, 'Address', ($this$keyString) => {
    var tmp0_safe_receiver = $this$keyString.baj($this.kjj_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k5c_1;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
  });
  keyString(view_3, 'Email', ($this$keyString) => {
    var tmp0_safe_receiver = $this$keyString.baj($this.kjj_1);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i5c_1;
  });
  keyString(view_3, 'Phone', ($this$keyString) => {
    var tmp0_safe_receiver = $this$keyString.baj($this.kjj_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j5c_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0 = PhoneNumberFormat_USA_getInstance();
      // Inline function 'kotlin.text.filter' call
      // Inline function 'kotlin.text.filterTo' call
      var destination = StringBuilder().d1();
      var inductionVariable = 0;
      var last = charSequenceLength(tmp1_safe_receiver);
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var element = charSequenceGet(tmp1_safe_receiver, index);
          if (isDigit(element)) {
            destination.xb(element);
          }
        }
         while (inductionVariable < last);
      var tmp$ret$21 = destination.toString();
      tmp = tmp_0.yda(takeLast(tmp$ret$21, 10));
    }
    return tmp;
  });
  view.fbb(p_3, view_3);
  view.jbb(tmp_4, view_3);
  var clientForm = {_v: null};
  var tmp_5 = mutableRemember(VOID, VOID, ProjectForm$billingInfo$lambda_0);
  clientForm._v = ClientForm().wjf(tmp_5, VOID, ProjectForm$billingInfo$slambda_2(clientSelection, $this, clientForm));
  view.jbb(view.ibb(shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp = $this$shownWhen.baj(clientSelection);
    return tmp instanceof New();
  }), billingInfo$_anonymous_$horizPadded_66h2xm(view)), render_0(clientForm._v, view));
  _this__u8e3s4.fbb(p, view);
  return view;
}
function projectDetailForm($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_rem(1));
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label = 'Project Description';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(get_AppDimensions().ng2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  view_1.zb8(get_AppDimensions().pg2_1);
  view_1.jbb(get_centered(view_1), bodyBold(view_1, label));
  view_1.jbb(colored(view_1, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_1, '*'));
  view_0.fbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view_0.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_0 = $this.bjj_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$5);
  var tmp$ret$7 = get_description(it);
  var tmp$ret$8 = lensPath(this_0, tmp$ret$7);
  var description = assertNotBlankNamed(tmp$ret$8, 'Description');
  var tmp_1 = view_0.ibb(sizeConstraints(view_0, VOID, VOID, get_rem(7)), get_expanding(view_0));
  var tmp_2 = view_0.ibb(tmp_1, validate(view_0, description, ($this$validate) => $this$validate.baj($this.ajj_1)));
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextArea())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.tcl('Project Description');
  view_2.xah(view_2.qcl_1, description);
  view_0.fbb(p_2, view_2);
  view_0.jbb(tmp_2, view_2);
  var tmp_3 = get_issues(description);
  var tmp$ret$12 = issueText(view_0, tmp_3, VOID, ($this$issueText) => $this$issueText.baj($this.ajj_1));
  view_0.jbb(tmp, tmp$ret$12);
  view.fbb(p_0, view_0);
  label2(view, 'Contractor Notes (Visible only to you)', VOID, ($this$label2) => {
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp$ret$18 = $this$label2.hbb(FieldSemantic_getInstance());
    var tmp = $this$label2.ibb(tmp$ret$18, sizeConstraints($this$label2, VOID, VOID, get_rem(10)));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$label2.pc());
    var tmp0_elvis_lhs = $this$label2.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
    $this$label2.ebb(p, view);
    view.xbm(false);
    var tmp_0 = get_expanding(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    var tmp_1 = get_centered(view_0);
    var tmp_2 = view_0.ibb(view_0.ibb(tmp_1, shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.baj($this.cjj_1).i1())), view_0.hbb(NothingHereSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.xbm(true);
    // Inline function 'com.crowpay.views.theming.boldSubTitle' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(SubtitleSemantic_getInstance().ybe(BoldSemantic_getInstance())));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = 'Nothing Yet';
    var tmp_3 = view_2.tb5_1;
    var tmp_4;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_4 = '\xA0';
    } else {
      tmp_4 = value;
    }
    tmp_3.fbu(tmp_4);
    view_2.bbs(Align_Center_getInstance());
    view_1.fbb(p_2, view_2);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (TextView())(view_1.pc());
    var tmp0_elvis_lhs_3 = view_1.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
    view_1.ebb(p_3, view_3);
    view_3.jba(view_3.ob6_1.ybe(SmallBodySemantic_getInstance()));
    view_3.bbs(Align_Center_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value_0 = 'Press the "+" button to add a note';
    var tmp_5 = view_3.tb5_1;
    var tmp_6;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value_0) === 0) {
      tmp_6 = '\xA0';
    } else {
      tmp_6 = value_0;
    }
    tmp_5.fbu(tmp_6);
    view_1.fbb(p_3, view_3);
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_2, view_1);
    var tmp_7 = get_scrollingHorizontally(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_4 = view_0.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
    view_0.ebb(p_4, view_4);
    view_4.xbm(false);
    view_4.zb8(get_rem_0(1.25));
    view_4.hb7(false);
    var tmp_8 = KMutableProperty0();
    var tmp_9 = RowOrCol$_get_shown_$ref_m8lfse_0(view_4);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp_8, tmp_9, RowOrCol$_set_shown_$ref_7290m6_0(view_4));
    reactiveScope(view_4, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$38 = !$this$reactiveScope.baj($this.cjj_1).i1();
      this_0.set(tmp$ret$38);
      return Unit_instance;
    });
    forEachUpdating(view_4, $this.cjj_1, 0, ($this$forEachUpdating, note) => {
      var index = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this.cjj_1).s1($this$remember.baj(note)) + 1 | 0);
      var tmp = $this$forEachUpdating.ibb(sizeConstraints($this$forEachUpdating, VOID, get_rem(25)), get_padded($this$forEachUpdating));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$forEachUpdating.pc());
      var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
      $this$forEachUpdating.ebb(p, view);
      view.xbm(true);
      view.zb8(get_rem(1));
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view_0.xbm(false);
      view_0.zb8(get_AppDimensions().pg2_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (RowOrCol())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.ebb(p_1, view_1);
      view_1.xbm(true);
      view_1.zb8(get_AppDimensions().pg2_1);
      // Inline function 'com.crowpay.views.theming.subTitle' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (TextView())(view_1.pc());
      var tmp0_elvis_lhs_2 = view_1.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
      view_1.ebb(p_2, view_2);
      view_2.jba(view_2.ob6_1.ybe(SubtitleSemantic_getInstance()));
      var tmp_0 = KMutableProperty0();
      var tmp_1 = TextView$_get_content_$ref_4pzcwl_1(view_2);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_1(view_2));
      reactiveScope(view_2, ($this$reactiveScope) => {
        var tmp$ret$40 = 'Private Note ' + $this$reactiveScope.baj(index);
        this_0.set(tmp$ret$40);
        return Unit_instance;
      });
      view_1.fbb(p_2, view_2);
      var tmp_2 = get_centered(view_1);
      // Inline function 'com.crowpay.views.theming.smallBody' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (TextView())(view_1.pc());
      var tmp0_elvis_lhs_3 = view_1.cbb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
      view_1.ebb(p_3, view_3);
      view_3.jba(view_3.ob6_1.ybe(SmallBodySemantic_getInstance()));
      var tmp_3 = KMutableProperty0();
      var tmp_4 = TextView$_get_content_$ref_4pzcwl_2(view_3);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_2(view_3));
      reactiveScope(view_3, ($this$reactiveScope) => {
        var tmp$ret$47 = formatLong($this$reactiveScope.baj(note).i5p_1);
        this_1.set(tmp$ret$47);
        return Unit_instance;
      });
      view_1.fbb(p_3, view_3);
      view_1.jbb(tmp_2, view_3);
      view_0.fbb(p_1, view_1);
      var tmp_5 = get_atTop(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (RowOrCol())(view_0.pc());
      var tmp0_elvis_lhs_4 = view_0.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
      view_0.ebb(p_4, view_4);
      view_4.xbm(false);
      view_4.zb8(get_rem_0(0.5));
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (Space())(view_4.pc());
      var tmp0_elvis_lhs_5 = view_4.cbb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
      view_4.ebb(p_5, view_5);
      view_4.fbb(p_5, view_5);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var tmp_6 = view_4.hbb(ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_6 = new (Button())(view_4.pc());
      var tmp0_elvis_lhs_6 = view_4.cbb_1;
      var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
      view_4.ebb(p_6, view_6);
      view_6.jbb(get_centered(view_6), icon(view_6, resize(get_edit(Companion_getInstance()), get_rem_0(1.1)), 'Edit'));
      onClick(view_6, VOID, VOID, ProjectForm$projectDetailForm$lambda$lambda$slambda_0(note));
      view_4.fbb(p_6, view_6);
      view_4.jbb(tmp_6, view_6);
      var tmp_7 = get_deleteButton(view_4);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_7 = new (Button())(view_4.pc());
      var tmp0_elvis_lhs_7 = view_4.cbb_1;
      var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
      view_4.ebb(p_7, view_7);
      view_7.eba(get_dp(1));
      view_7.zb8(get_dp(1));
      view_7.jbb(get_centered(view_7), icon(view_7, resize(get_trash(Companion_getInstance()), get_rem_0(1.1)), 'Delete'));
      onClick(view_7, VOID, VOID, ProjectForm$projectDetailForm$lambda$lambda$slambda_2(note));
      view_4.fbb(p_7, view_7);
      view_4.jbb(tmp_7, view_7);
      view_0.fbb(p_4, view_4);
      view_0.jbb(tmp_5, view_4);
      view.fbb(p_0, view_0);
      var tmp_8 = sizeConstraints(view, VOID, VOID, VOID, get_rem(20));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_8 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_8 = view.cbb_1;
      var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
      view.ebb(p_8, view_8);
      view_8.jba(view_8.ob6_1.ybe(BodySemantic_getInstance()));
      view_8.yco(true);
      view_8.xco(true);
      var tmp_9 = KMutableProperty0();
      var tmp_10 = TextView$_get_content_$ref_4pzcwl_3(view_8);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_2 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_3(view_8));
      reactiveScope(view_8, ($this$reactiveScope) => {
        var tmp$ret$76 = $this$reactiveScope.baj(note).g5p_1;
        this_2.set(tmp$ret$76);
        return Unit_instance;
      });
      view.fbb(p_8, view_8);
      view.jbb(tmp_8, view_8);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_9 = new (Frame())(view.pc());
      var tmp0_elvis_lhs_9 = view.cbb_1;
      var p_9 = tmp0_elvis_lhs_9 == null ? view : tmp0_elvis_lhs_9;
      view.ebb(p_9, view_9);
      var f = lens(note, ProjectForm$projectDetailForm$lambda$lambda$lambda);
      var tmp_11 = KMutableProperty0();
      var tmp_12 = Frame$_get_shown_$ref_dnks5k(view_9);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_3 = getPropertyCallableRef('shown', 0, tmp_11, tmp_12, Frame$_set_shown_$ref_s2otf0(view_9));
      reactiveScope(view_9, ($this$reactiveScope) => {
        // Inline function 'kotlin.collections.isNotEmpty' call
        var tmp$ret$84 = !$this$reactiveScope.baj(f).i1();
        this_3.set(tmp$ret$84);
        return Unit_instance;
      });
      label2(view_9, 'Files: ', VOID, ($this$label2) => renderFiles($this$label2, f, get_AppDimensions().rg2_1));
      view.fbb(p_9, view_9);
      $this$forEachUpdating.fbb(p, view);
      $this$forEachUpdating.jbb(tmp, view);
      return Unit_instance;
    });
    view_0.fbb(p_4, view_4);
    view_0.jbb(tmp_7, view_4);
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
    var tmp_10 = view.ibb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, div(get_AppDimensions().qg2_1, 3)), get_tertiaryButton(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (Button())(view.pc());
    var tmp0_elvis_lhs_5 = view.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
    view.ebb(p_5, view_5);
    var tmp_11 = Companion_getInstance().wcf_1;
    iconAndAction(view_5, tmp_11, 'Add Note', ProjectForm$projectDetailForm$lambda$slambda_0($this));
    view.fbb(p_5, view_5);
    view.jbb(tmp_10, view_5);
    $this$label2.fbb(p, view);
    return $this$label2.jbb(tmp, view);
  });
  label2(view, 'Project Files (Images, Bids, Plans, Specs)', VOID, ($this$label2) => {
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp = $this$label2.hbb(FieldSemantic_getInstance());
    return $this$label2.jbb(tmp, fileManager($this$label2, $this.djj_1, 'No Files Uploaded', VOID, VOID, ProjectForm$projectDetailForm$lambda$slambda_2()));
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function assertProjectContractor($this, _this__u8e3s4) {
  return launch(_this__u8e3s4, VOID, VOID, ProjectForm$assertProjectContractor$slambda_0($this, _this__u8e3s4));
}
function section($this, _this__u8e3s4, section) {
  return shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => $this$shownWhen.baj($this.wji_1).equals(section));
}
function renderOld($this, _this__u8e3s4) {
  var infoExpanded = Signal().fak(true);
  var billingInfoExpanded = Signal().fak(true);
  var tmp = get_scrolling(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_dp(0));
  assertProjectContractor($this, view);
  var tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(get_AppDimensions().zg1_1);
  title(view_0, 'Create Project');
  actionBar($this, view_0);
  var tmp_1 = shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.baj($this.yji_1) && $this$shownWhen.baj($this.mjj_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(true);
  view_1.jbb(notificationBar(view_1, AppColors_getInstance().ifz_1), body(view_1, 'Projects can only by published by contractors registered to operate in approved states.'));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Space())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_1.fbb(p_2, view_2);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().gg2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowCollapsingToColumn())(view_0.pc(), listOf_0(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs_3 = view_0.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.ebb(p_3, view_3);
  var tmp_2 = get_expanding(view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.ebb(p_4, view_4);
  view_4.xbm(true);
  leftExpandButton(view_4, infoExpanded, false, VOID, VOID, VOID, ProjectForm$renderOld$lambda);
  view_4.bbn(get_px(0));
  greySeparator(view_4);
  view_4.jbb(shownWhen(view_4, VOID, ($this$shownWhen) => $this$shownWhen.baj(infoExpanded)), projectInfo($this, view_4));
  view_3.fbb(p_4, view_4);
  view_3.jbb(tmp_2, view_4);
  var tmp_3 = get_expanding(view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_5 = view_3.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
  view_3.ebb(p_5, view_5);
  view_5.xbm(true);
  leftExpandButton(view_5, billingInfoExpanded, false, VOID, VOID, VOID, ProjectForm$renderOld$lambda_0);
  view_5.bbn(get_px(0));
  greySeparator(view_5);
  view_5.jbb(shownWhen(view_5, VOID, ($this$shownWhen) => $this$shownWhen.baj(billingInfoExpanded)), billingInfo($this, view_5));
  view_3.fbb(p_5, view_5);
  view_3.jbb(tmp_3, view_5);
  view_0.fbb(p_3, view_3);
  var tmp_4 = get_workTabs(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_6 = view_0.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
  view_0.ebb(p_6, view_6);
  view_6.xbm(false);
  reactive(view_6, ($this$reactive) => {
    var tmp;
    if ($this$reactive.baj($this.ajj_1)) {
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$this$reactive.baj($this.ejj_1.pat_1).i1()) {
        $this.wji_1.mam(Section_Scope_getInstance());
        tmp_0 = Unit_instance;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this$reactive.baj(get_issues($this.bjj_1)).i1()) {
          $this.wji_1.mam(Section_Details_getInstance());
          tmp_0 = Unit_instance;
        }
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  });
  var tmp_5 = get_expanding(view_6);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$20 = view_6.hbb(ButtonSemantic_getInstance());
  var tmp_6 = view_6.ibb(tmp_5, tmp$ret$20);
  // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RadioToggleButton())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.ebb(p_7, view_7);
  view_7.xah(view_7.zc8_1, equalTo($this.wji_1, Section_Details_getInstance()));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.ebb(p_8, view_8);
  view_8.jba(view_8.ob6_1.ybe(BodySemantic_getInstance()));
  view_8.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_7 = view_8.tb5_1;
  var tmp_8;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Details') === 0) {
    tmp_8 = '\xA0';
  } else {
    tmp_8 = 'Details';
  }
  tmp_7.fbu(tmp_8);
  view_7.fbb(p_8, view_8);
  view_6.fbb(p_7, view_7);
  view_6.jbb(tmp_6, view_7);
  var tmp_9 = get_expanding(view_6);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$31 = view_6.hbb(ButtonSemantic_getInstance());
  var tmp_10 = view_6.ibb(tmp_9, tmp$ret$31);
  // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RadioToggleButton())(view_6.pc());
  var tmp0_elvis_lhs_9 = view_6.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_6 : tmp0_elvis_lhs_9;
  view_6.ebb(p_9, view_9);
  view_9.xah(view_9.zc8_1, equalTo($this.wji_1, Section_Scope_getInstance()));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (TextView())(view_9.pc());
  var tmp0_elvis_lhs_10 = view_9.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
  view_9.ebb(p_10, view_10);
  view_10.jba(view_10.ob6_1.ybe(BodySemantic_getInstance()));
  view_10.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_11 = view_10.tb5_1;
  var tmp_12;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Scope') === 0) {
    tmp_12 = '\xA0';
  } else {
    tmp_12 = 'Scope';
  }
  tmp_11.fbu(tmp_12);
  view_9.fbb(p_10, view_10);
  view_6.fbb(p_9, view_9);
  view_6.jbb(tmp_10, view_9);
  view_0.fbb(p_6, view_6);
  view_0.jbb(tmp_4, view_6);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_11 = view_0.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_0 : tmp0_elvis_lhs_11;
  view_0.ebb(p_11, view_11);
  view_11.xbm(true);
  reactive(view_11, ($this$reactive) => {
    var tmp;
    if (setOf([Section_Info_getInstance(), Section_Billing_getInstance()]).t1($this$reactive.baj($this.wji_1))) {
      $this.wji_1.mam(Section_Details_getInstance());
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  var tmp_13 = sizeConstraints(view_11, VOID, VOID, get_rem(10));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (RowOrCol())(view_11.pc());
  var tmp0_elvis_lhs_12 = view_11.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
  view_11.ebb(p_12, view_12);
  view_12.xbm(false);
  view_12.jbb(view_12.ibb(get_expanding(view_12), section($this, view_12, Section_Details_getInstance())), projectDetailForm($this, view_12));
  view_12.jbb(view_12.ibb(get_expanding(view_12), section($this, view_12, Section_Scope_getInstance())), render_0($this.fjj_1, view_12));
  view_11.fbb(p_12, view_12);
  view_11.jbb(tmp_13, view_12);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (Space())(view_11.pc(), 2.0);
  var tmp0_elvis_lhs_13 = view_11.cbb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
  view_11.ebb(p_13, view_13);
  view_11.fbb(p_13, view_13);
  view_0.fbb(p_11, view_11);
  var tmp_14 = shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.baj($this.yji_1) && $this$shownWhen.baj($this.mjj_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_14 = view_0.cbb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_0 : tmp0_elvis_lhs_14;
  view_0.ebb(p_14, view_14);
  view_14.xbm(true);
  view_14.jbb(notificationBar(view_14, AppColors_getInstance().ifz_1), body(view_14, 'Projects can only by published by contractors registered to operate in approved states.'));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (Space())(view_14.pc());
  var tmp0_elvis_lhs_15 = view_14.cbb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
  view_14.ebb(p_15, view_15);
  view_14.fbb(p_15, view_15);
  view_0.fbb(p_14, view_14);
  view_0.jbb(tmp_14, view_14);
  actionBar($this, view_0);
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function renderNarrow($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var tmp = view.ibb(get_expanding(view), get_scrolling(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(get_AppDimensions().zg1_1);
  assertProjectContractor($this, view_0);
  title(view_0, 'Create Project');
  view_0.jbb(view_0.ibb(shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.baj($this.yji_1) && $this$shownWhen.baj($this.mjj_1)), notificationBar(view_0, AppColors_getInstance().ifz_1)), body(view_0, 'Projects can only by published by contractors registered to operate in approved states.'));
  var tmp_0 = view_0.hbb(InnerTabBar_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  var _iterator__ex2g4s = get_entries().m1();
  while (_iterator__ex2g4s.n1()) {
    var section_0 = _iterator__ex2g4s.o1();
    var tmp_1 = weight(view_1, 1.0 + 0.1 * (section_0.fjl_1.length - 5 | 0));
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var tmp$ret$0 = view_1.hbb(ButtonSemantic_getInstance());
    var tmp_2 = view_1.ibb(tmp_1, tmp$ret$0);
    // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RadioToggleButton())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    view_2.xah(view_2.zc8_1, equalTo($this.wji_1, section_0));
    view_2.jbb(get_centered(view_2), body(view_2, section_0.fjl_1));
    view_1.fbb(p_2, view_2);
    view_1.jbb(tmp_2, view_2);
  }
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Frame())(view_0.pc());
  var tmp0_elvis_lhs_3 = view_0.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.ebb(p_3, view_3);
  view_3.jbb(section($this, view_3, Section_Info_getInstance()), projectInfo($this, view_3));
  view_3.jbb(section($this, view_3, Section_Details_getInstance()), projectDetailForm($this, view_3));
  view_3.jbb(section($this, view_3, Section_Billing_getInstance()), billingInfo($this, view_3));
  view_3.jbb(section($this, view_3, Section_Scope_getInstance()), render_0($this.fjj_1, view_3));
  view_0.fbb(p_3, view_3);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  actionBar($this, view);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function actionBar$saveButton(_this__u8e3s4, this$0) {
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  specCenteredText(view, 'Save');
  onClick(view, VOID, VOID, ProjectForm$actionBar$saveButton$slambda_0(this$0, view));
  _this__u8e3s4.fbb(p, view);
  return view;
}
function actionBar$saveAndCloseButton(_this__u8e3s4, this$0) {
  var tmp = get_secondaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  specCenteredText(view, 'Save & Close');
  onClick(view, VOID, VOID, ProjectForm$actionBar$saveAndCloseButton$slambda_0(this$0, view));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actionBar$discardButton(_this__u8e3s4) {
  var tmp = get_textButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  specCenteredText(view, 'Discard');
  onClick(view, VOID, VOID, ProjectForm$actionBar$discardButton$slambda_0(view));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actionBar$deleteButton(_this__u8e3s4, this$0) {
  var tmp = get_deleteButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jbb(get_centered(view), icon(view, resize(get_trash(Companion_getInstance()), get_rem_0(1.2)), 'Delete Project'));
  onClick(view, VOID, VOID, ProjectForm$actionBar$deleteButton$slambda_0(this$0, view));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actionBar$publishButton(_this__u8e3s4, this$0) {
  var tmp = get_primaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  specCenteredText(view, 'Publish');
  onClick(view, VOID, VOID, ProjectForm$actionBar$publishButton$slambda_0(this$0, view));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actionBar$publishButton$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderIssue_eqxfvq(_this__u8e3s4, issue) {
  return body(_this__u8e3s4, '\u2022 ' + issue.q91());
}
function billingInfo$_anonymous_$horizPadded_66h2xm(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.bbb_1;
  var tmp = _this__u8e3s4;
  tmp.bbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    _this__u8e3s4.hba(Edges().cd0(_this__u8e3s4.kba().hb0_1, get_px(0)));
    return Unit_instance;
  };
  return Companion_getInstance_0();
}
var ProjectForm$editLineItems$slambdaClass;
function ProjectForm$editLineItems$slambda() {
  if (ProjectForm$editLineItems$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.kjl_1 = this$0;
      }
      whq(item, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, item), $completion);
      }
      s2(p1, $completion) {
        return this.whq((p1 == null ? true : p1 instanceof LineItem()) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$editLineItems$slambdaClass = $;
  }
  return ProjectForm$editLineItems$slambdaClass;
}
function ProjectForm$editLineItems$slambda_0(this$0) {
  var i = new (ProjectForm$editLineItems$slambda())(this$0);
  var l = (item, $completion) => i.whq(item, $completion);
  l.$arity = 1;
  return l;
}
function ProjectForm$clients$lambda($this$remember) {
  var tmp = $this$remember.baj(get_session()).ifv_1;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$0);
  var tmp_1 = eq(get_contractor(it), $this$remember.baj(get_notNullContractor()));
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$5);
  get_name_0(it_0);
  var tmp$ret$10 = this_0.o1r();
  return $this$remember.baj(tmp.feo(new (Query())(tmp_1, tmp$ret$10)));
}
var ProjectForm$saveProject$slambdaClass;
function ProjectForm$saveProject$slambda() {
  if (ProjectForm$saveProject$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $includeLineItems) {
        this.njl_1 = this$0;
        this.ojl_1 = $includeLineItems;
      }
      wah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$saveProject$slambdaClass = $;
  }
  return ProjectForm$saveProject$slambdaClass;
}
function ProjectForm$saveProject$slambda_0(this$0, $includeLineItems) {
  var i = new (ProjectForm$saveProject$slambda())(this$0, $includeLineItems);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var ProjectForm$saveProject$slambdaClass_0;
function ProjectForm$saveProject$slambda_1() {
  if (ProjectForm$saveProject$slambdaClass_0 === VOID) {
    class $ {
      constructor($cont) {
        this.qjm_1 = $cont;
      }
      cgk(includeWorkItems, $completion) {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = this.qjm_1;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$0 = _Result___init__impl__xyqfz8(includeWorkItems);
        this_0.rc(tmp$ret$0);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$saveProject$slambdaClass_0 = $;
  }
  return ProjectForm$saveProject$slambdaClass_0;
}
function ProjectForm$saveProject$slambda_2($cont) {
  var i = new (ProjectForm$saveProject$slambda_1())($cont);
  var l = (includeWorkItems, $completion) => i.cgk(includeWorkItems, $completion);
  l.$arity = 1;
  return l;
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var ProjectForm$projectInfo$slambdaClass;
function ProjectForm$projectInfo$slambda() {
  if (ProjectForm$projectInfo$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.rjl_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$projectInfo$slambdaClass = $;
  }
  return ProjectForm$projectInfo$slambdaClass;
}
function ProjectForm$projectInfo$slambda_0(this$0) {
  var i = new (ProjectForm$projectInfo$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function ProjectForm$projectInfo$lambda(it) {
  var tmp1_safe_receiver = it == null ? null : it * 100;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : round(tmp1_safe_receiver, 2);
  return tmp2_safe_receiver == null ? null : tmp2_safe_receiver;
}
function ProjectForm$projectInfo$lambda_0(it) {
  var tmp1_safe_receiver = it == null ? null : it;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_0;
    if (!(tmp1_safe_receiver === 0.0)) {
      tmp_0 = tmp1_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp2_safe_receiver = tmp;
  return tmp2_safe_receiver == null ? null : tmp2_safe_receiver / 100;
}
function ProjectForm$projectInfo$lambda_1(it) {
  var tmp;
  if (it == null) {
    tmp = true;
  } else {
    tmp = 0.0 <= it ? it <= 5.0 : false;
  }
  return tmp;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var ProjectForm$billingInfo$slambdaClass;
function ProjectForm$billingInfo$slambda() {
  if (ProjectForm$billingInfo$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.rjm_1 = this$0;
      }
      sjm($this$interceptWrite, it, $completion) {
        if (it instanceof Existing()) {
          set_value(this.rjm_1.kjj_1, it.jjl_1);
        }
        set_value($this$interceptWrite, it);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, ReactiveWithMutableValue()) : false) ? p1 : THROW_CCE();
        return this.sjm(tmp, p2 instanceof ClientSelection() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ProjectForm$billingInfo$slambdaClass = $;
  }
  return ProjectForm$billingInfo$slambdaClass;
}
function ProjectForm$billingInfo$slambda_0(this$0) {
  var i = new (ProjectForm$billingInfo$slambda())(this$0);
  var l = ($this$interceptWrite, it, $completion) => i.sjm($this$interceptWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function ProjectForm$billingInfo$lambda(it) {
  return it.g90();
}
function ProjectForm$billingInfo$lambda_0($this$mutableRemember) {
  return new (Client())(VOID, $this$mutableRemember.baj(get_notNullContractor()), '', VOID, VOID, '', '', new (Address())());
}
var ProjectForm$billingInfo$slambdaClass_0;
function ProjectForm$billingInfo$slambda_1() {
  if (ProjectForm$billingInfo$slambdaClass_0 === VOID) {
    class $ {
      constructor($clientSelection, this$0, $clientForm) {
        this.sjl_1 = $clientSelection;
        this.tjl_1 = this$0;
        this.ujl_1 = $clientForm;
      }
      vjf(newClient, saved, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, newClient, saved), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof Client() ? p1 : THROW_CCE();
        return this.vjf(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ProjectForm$billingInfo$slambdaClass_0 = $;
  }
  return ProjectForm$billingInfo$slambdaClass_0;
}
function ProjectForm$billingInfo$slambda_2($clientSelection, this$0, $clientForm) {
  var i = new (ProjectForm$billingInfo$slambda_1())($clientSelection, this$0, $clientForm);
  var l = (newClient, saved, $completion) => i.vjf(newClient, saved, $completion);
  l.$arity = 2;
  return l;
}
function RowOrCol$_get_shown_$ref_m8lfse_0(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6_0(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var ProjectForm$projectDetailForm$lambda$lambda$slambdaClass;
function ProjectForm$projectDetailForm$lambda$lambda$slambda() {
  if (ProjectForm$projectDetailForm$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($note) {
        this.vjl_1 = $note;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$projectDetailForm$lambda$lambda$slambdaClass = $;
  }
  return ProjectForm$projectDetailForm$lambda$lambda$slambdaClass;
}
function ProjectForm$projectDetailForm$lambda$lambda$slambda_0($note) {
  var i = new (ProjectForm$projectDetailForm$lambda$lambda$slambda())($note);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ProjectForm$projectDetailForm$lambda$lambda$slambdaClass_0;
function ProjectForm$projectDetailForm$lambda$lambda$slambda_1() {
  if (ProjectForm$projectDetailForm$lambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($note) {
        this.tjm_1 = $note;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        var tmp0_confirmationTheme = DangerButtonSemantic_getInstance();
        tmp.xgd(new (GenericConfirmationDialog())('Delete Note', 'Are you sure you want to delete this note?', VOID, 'Delete', VOID, tmp0_confirmationTheme, VOID, VOID, VOID, VOID, ProjectForm$projectDetailForm$lambda$lambda$slambda$slambda_0(this.tjm_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$projectDetailForm$lambda$lambda$slambdaClass_0 = $;
  }
  return ProjectForm$projectDetailForm$lambda$lambda$slambdaClass_0;
}
function ProjectForm$projectDetailForm$lambda$lambda$slambda_2($note) {
  var i = new (ProjectForm$projectDetailForm$lambda$lambda$slambda_1())($note);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ProjectForm$projectDetailForm$lambda$lambda$lambda(it) {
  return it.h5p_1;
}
function Frame$_get_shown_$ref_dnks5k(p0) {
  return () => p0.wb8();
}
function Frame$_set_shown_$ref_s2otf0(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var ProjectForm$projectDetailForm$lambda$slambdaClass;
function ProjectForm$projectDetailForm$lambda$slambda() {
  if (ProjectForm$projectDetailForm$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.yjl_1 = this$0;
      }
      wah($this$iconAndAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$iconAndAction), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$projectDetailForm$lambda$slambdaClass = $;
  }
  return ProjectForm$projectDetailForm$lambda$slambdaClass;
}
function ProjectForm$projectDetailForm$lambda$slambda_0(this$0) {
  var i = new (ProjectForm$projectDetailForm$lambda$slambda())(this$0);
  var l = ($this$iconAndAction, $completion) => i.wah($this$iconAndAction, $completion);
  l.$arity = 1;
  return l;
}
var ProjectForm$projectDetailForm$lambda$slambdaClass_0;
function ProjectForm$projectDetailForm$lambda$slambda_1() {
  if (ProjectForm$projectDetailForm$lambda$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$projectDetailForm$lambda$slambdaClass_0 = $;
  }
  return ProjectForm$projectDetailForm$lambda$slambdaClass_0;
}
function ProjectForm$projectDetailForm$lambda$slambda_2() {
  var i = new (ProjectForm$projectDetailForm$lambda$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ProjectForm$assertProjectContractor$slambdaClass;
function ProjectForm$assertProjectContractor$slambda() {
  if (ProjectForm$assertProjectContractor$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_assertProjectContractor) {
        this.ajm_1 = this$0;
        this.bjm_1 = $this_assertProjectContractor;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectForm$assertProjectContractor$slambdaClass = $;
  }
  return ProjectForm$assertProjectContractor$slambdaClass;
}
function ProjectForm$assertProjectContractor$slambda_0(this$0, $this_assertProjectContractor) {
  var i = new (ProjectForm$assertProjectContractor$slambda())(this$0, $this_assertProjectContractor);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function ProjectForm$renderOld$lambda($this$leftExpandButton) {
  boldSubTitle($this$leftExpandButton, 'Project Information');
  return Unit_instance;
}
function ProjectForm$renderOld$lambda_0($this$leftExpandButton) {
  boldSubTitle($this$leftExpandButton, 'Billing Information');
  return Unit_instance;
}
var ProjectForm$actionBar$saveButton$slambdaClass;
function ProjectForm$actionBar$saveButton$slambda() {
  if (ProjectForm$actionBar$saveButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.cjm_1 = this$0;
        this.djm_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$actionBar$saveButton$slambdaClass = $;
  }
  return ProjectForm$actionBar$saveButton$slambdaClass;
}
function ProjectForm$actionBar$saveButton$slambda_0(this$0, $$this$button) {
  var i = new (ProjectForm$actionBar$saveButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ProjectForm$actionBar$saveAndCloseButton$slambdaClass;
function ProjectForm$actionBar$saveAndCloseButton$slambda() {
  if (ProjectForm$actionBar$saveAndCloseButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.fjm_1 = this$0;
        this.gjm_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$actionBar$saveAndCloseButton$slambdaClass = $;
  }
  return ProjectForm$actionBar$saveAndCloseButton$slambdaClass;
}
function ProjectForm$actionBar$saveAndCloseButton$slambda_0(this$0, $$this$button) {
  var i = new (ProjectForm$actionBar$saveAndCloseButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ProjectForm$actionBar$discardButton$slambdaClass;
function ProjectForm$actionBar$discardButton$slambda() {
  if (ProjectForm$actionBar$discardButton$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.ujm_1 = $$this$button;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        tmp.xgd(new (GenericConfirmationDialog())('Discard Changes?', 'You have changes that have not been submitted. Discarded changes cannot be recovered. Discard changes and leave?', VOID, 'Discard & Leave', VOID, VOID, VOID, VOID, VOID, VOID, ProjectForm$actionBar$discardButton$slambda$slambda_0(this.ujm_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$actionBar$discardButton$slambdaClass = $;
  }
  return ProjectForm$actionBar$discardButton$slambdaClass;
}
function ProjectForm$actionBar$discardButton$slambda_0($$this$button) {
  var i = new (ProjectForm$actionBar$discardButton$slambda())($$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ProjectForm$actionBar$deleteButton$slambdaClass;
function ProjectForm$actionBar$deleteButton$slambda() {
  if (ProjectForm$actionBar$deleteButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.vjm_1 = this$0;
        this.wjm_1 = $$this$button;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.xgd(new (GenericConfirmationDialog())('Delete Draft?', 'You are about to delete this project draft. Deleted drafts cannot be recovered. Delete this draft?', VOID, 'Delete Draft', VOID, tmp_0, VOID, VOID, VOID, VOID, ProjectForm$actionBar$deleteButton$slambda$slambda_0(this.vjm_1, this.wjm_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$actionBar$deleteButton$slambdaClass = $;
  }
  return ProjectForm$actionBar$deleteButton$slambdaClass;
}
function ProjectForm$actionBar$deleteButton$slambda_0(this$0, $$this$button) {
  var i = new (ProjectForm$actionBar$deleteButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ProjectForm$actionBar$publishButton$slambdaClass;
function ProjectForm$actionBar$publishButton$slambda() {
  if (ProjectForm$actionBar$publishButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.mjm_1 = this$0;
        this.njm_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectForm$actionBar$publishButton$slambdaClass = $;
  }
  return ProjectForm$actionBar$publishButton$slambdaClass;
}
function ProjectForm$actionBar$publishButton$slambda_0(this$0, $$this$button) {
  var i = new (ProjectForm$actionBar$publishButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Section_Billing_getInstance() {
  Section_initEntries();
  return Section_Billing_instance;
}
function Section_Info_getInstance() {
  Section_initEntries();
  return Section_Info_instance;
}
function Section_Details_getInstance() {
  Section_initEntries();
  return Section_Details_instance;
}
function Section_Scope_getInstance() {
  Section_initEntries();
  return Section_Scope_instance;
}
var ProjectFormClass;
function ProjectForm() {
  if (ProjectFormClass === VOID) {
    class $ {
      constructor(projectId, selectedTab) {
        selectedTab = selectedTab === VOID ? Signal().fak(Section_Billing_getInstance()) : selectedTab;
        this.vji_1 = projectId;
        this.wji_1 = selectedTab;
        this.xji_1 = _Constant___init__impl__v45mub('Create Project');
        var tmp = this;
        tmp.yji_1 = remember(VOID, VOID, VOID, ($this$remember) => !($this$remember.baj($this$remember.baj(get_session()).pfv_1.kft(this.vji_1)) == null));
        this.zji_1 = new (IssueNode())();
        this.ajj_1 = Signal().fak(false);
        var tmp_0 = this;
        tmp_0.bjj_1 = validated(Draft(($this$Draft) => {
          var tmp0_elvis_lhs = $this$Draft.baj($this$Draft.baj(get_session()).pfv_1.kft(this.vji_1));
          return tmp0_elvis_lhs == null ? new (Project())(this.vji_1, VOID, $this$Draft.baj(get_notNullContractor()), ensureNotNull($this$Draft.baj(get_currentContractor())).w5i_1, VOID, VOID, '', '', new (Address())(), '') : tmp0_elvis_lhs;
        }), this.zji_1);
        var tmp_1 = this;
        tmp_1.cjj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).zfv_1;
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ContractorNote()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$0);
          this_0.m4a(get_at(it));
          // Inline function 'com.lightningkite.lightningdb.Query' call
          var orderBy = this_0.o1r();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(ContractorNote()), arrayOf([]), false));
          var tmp$ret$6 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$6);
          var tmp$ret$8 = eq(get_project(it_0), this.vji_1);
          var tmp$ret$9 = new (Query())(tmp$ret$8, orderBy, 0, 100);
          return $this$remember.baj(tmp.feo(tmp$ret$9));
        });
        var tmp_2 = this;
        tmp_2.djj_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => toFileData($this$mutableRemember.baj(this.bjj_1).i7b_1));
        this.ejj_1 = this.zji_1.tat();
        var tmp_3 = this;
        var tmp_4 = ($this$EditLineItems) => $this$EditLineItems.baj(this.ajj_1);
        tmp_3.fjj_1 = new (EditLineItems())(this.vji_1, this.yji_1, this.ejj_1, tmp_4, ProjectForm$editLineItems$slambda_0(this));
        var tmp_5 = this;
        // Inline function 'kotlin.apply' call
        var this_0 = this.ejj_1.tat();
        assertReactive(this_0, 'You must include at least one work item in your project', VOID, ($this$assertReactive) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$assertReactive.baj(this.fjj_1.kho_1).i1();
        });
        tmp_5.gjj_1 = this_0;
        var tmp_6 = this;
        tmp_6.hjj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var this_0 = $this$remember.baj(this.fjj_1.kho_1);
          var sum = Companion_instance_0.p91(0n);
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp = sum;
            var tmp$ret$13 = $this$remember.baj(element.chn_1).n6k_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$13);
          }
          var tmp$ret$14 = sum;
          return new (MonetaryValue())(tmp$ret$14);
        });
        var tmp_7 = this;
        tmp_7.ijj_1 = remember(VOID, VOID, VOID, ProjectForm$clients$lambda);
        var tmp_8 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_1 = this.bjj_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_9 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
        var tmp$ret$15 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$15);
        var tmp$ret$17 = get_client(it);
        tmp_8.jjj_1 = lensPath(this_1, tmp$ret$17);
        var tmp_10 = this;
        tmp_10.kjj_1 = MutableRemember().rak(VOID, VOID, VOID, VOID, ($this$MutableRemember) => {
          var c = $this$MutableRemember.baj(this.ijj_1);
          var tmp0_elvis_lhs = $this$MutableRemember.baj(this.jjj_1);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return null;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var p = tmp;
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$20;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = c.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.d5c_1.equals(p)) {
                tmp$ret$20 = element;
                break $l$block;
              }
            }
            tmp$ret$20 = null;
          }
          return tmp$ret$20;
        });
        var tmp_11 = this;
        tmp_11.ljj_1 = MutableRemember().rak(VOID, VOID, VOID, VOID, ($this$MutableRemember) => {
          var address = $this$MutableRemember.eaj(this.bjj_1).f7b_1;
          var tmp;
          if (isNotBlank(address)) {
            var tmp0_safe_receiver = $this$MutableRemember.eaj(this.kjj_1);
            tmp = address.equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k5c_1);
          } else {
            tmp = false;
          }
          return tmp;
        });
        var tmp_12 = this;
        tmp_12.mjj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var relevantState = $this$remember.baj(this.bjj_1).f7b_1.u55_1;
          var session = $this$remember.baj(get_session());
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(License()), arrayOf([]), false));
          var tmp$ret$22 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$22);
          var tmp$ret$26 = eq(get_contractor_0(it), $this$remember.baj(get_notNullContractor()));
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.baj(session.lfv_1.feo(new (Query())(tmp$ret$26)));
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$27 = item.a6f_1;
            destination.v(tmp$ret$27);
          }
          var licensedStates = destination;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ApprovedState()), arrayOf([]), false));
          var tmp$ret$30 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$30);
          var tmp$ret$34 = eq(get_approved(it_0), true);
          // Inline function 'kotlin.collections.map' call
          var this_1 = $this$remember.baj(session.xfv_1.feo(new (Query())(tmp$ret$34)));
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().u(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s_0 = this_1.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var item_0 = _iterator__ex2g4s_0.o1();
            var tmp$ret$35 = item_0.b57_1;
            destination_0.v(tmp$ret$35);
          }
          var approvedStates = destination_0;
          return !approvedStates.t1(relevantState) || !licensedStates.t1(relevantState);
        });
        var tmp_13 = this;
        tmp_13.njj_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(this.yji_1) && !$this$remember.baj(this.bjj_1.aak()) && $this$remember.baj(this.fjj_1.lho_1));
      }
      wd6() {
        return this.xji_1;
      }
      ucv() {
        return new (Constant())(this.wd6());
      }
      ug9() {
        return this.njj_1;
      }
      ljl(includeLineItems, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_saveProject__mbt0ko.bind(VOID, this, includeLineItems), $completion);
      }
      ejm(_this__u8e3s4, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_saveProject__mbt0ko_0.bind(VOID, this, _this__u8e3s4), $completion);
      }
      rhi(_this__u8e3s4) {
        if (get_viewIsNarrow(_this__u8e3s4))
          renderNarrow(this, _this__u8e3s4);
        else
          renderOld(this, _this__u8e3s4);
      }
    }
    protoOf($).bhg = get_requiredMembershipRole;
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    protoOf($).ud6 = render;
    initMetadataForClass($, 'ProjectForm', VOID, VOID, [ContractorPage(), Form()], [1]);
    ProjectFormClass = $;
  }
  return ProjectFormClass;
}
//region block: exports
export {
  EditProject as EditProject1iovryfu514gb,
  Section as Section1t8b1ogi8i5xd,
  ProjectForm as ProjectForm1zulspgp9ne98,
  Section_Details_getInstance as Section_Details_getInstance2utxmlnygugd3,
};
//endregion

//# sourceMappingURL=EditProject.mjs.map
